import axios from '@/utils/request'
var Qs = require('qs')
export default {
	workflowStates: ['newly', 'partially', 'finish'],

	// 2021-01-09
	search(params) {
		return axios.get('/mms/requisitions?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-01-08
	createByOrder(params) {
		return axios.post('/mms/requisitions/create-by-order', params)
	},
	// 2021-01-08
	directFeedOrder(params) {
		return axios.post('/mms/requisitions/direct-feed-order', params)
	},
	// 2021-01-09
	createByPurchase(params) {
		return axios.post('/mms/requisitions/create-by-purchase ', params)
	},
	// 2021-01-09
	directFeedPurchase(params) {
		return axios.post('/mms/requisitions/direct-feed-purchase', params)
	},
	// 2021-01-08
	batchIgnoreFeedOrder(params) {
		return axios.post('/mms/requisitions/batch-ignore-feed-order', params)
	},
	// 2021-01-09
	batchIgnoreFeedPurchase(params) {
		return axios.post('/mms/requisitions/batch-ignore-feed-purchase', params)
	},

	// customInsert(params) {
	// 	return axios.post('/mms/requisitions/custom-insert ', params)
	// },
	// 2021-01-09
	update(id, params) {
		return axios.put('/mms/requisitions/' + id, params)
	},
	// 2021-01-09
	delete(id) {
		return axios.delete('/mms/requisitions/' + id)
	},
	// 2021-01-09
	findById(id) {
		return axios.get('/mms/requisitions/' + id)
	},
	// 2021-01-09
	materials(id) {
		return axios.get('/mms/requisitions/' + id + '/materials')
	},
	// 2021-01-09
	orders(id) {
		return axios.get('/mms/requisitions/' + id + '/orders')
	},
	// 2021-01-09
	purchases(id) {
		return axios.get('/mms/requisitions/' + id + '/purchases')
	},
	// 2021-01-16
	batchGive(id, params) {
		return axios.put('/mms/requisitions/' + id + '/materials/give-batch', params)
	},
	// 2021-07-26
	manualGiveBatch(id, params) {
		return axios.put('/mms/requisitions/' + id + '/materials/manual-give-batch', params)
	},
	// 2021-07-26
	autoGiveBatch(id, params) {
		return axios.put('/mms/requisitions/' + id + '/materials/auto-give-batch', params)
	},
	// 2021-01-16
	batchFinish(params) {
		return axios.put('/mms/requisitions/materials/batch-finish', params)
	},
	// 2021-01-16
	change(id, requisitionMaterialId, params) {
		return axios.put('/mms/requisitions/' + id + '/requisition-material/' + requisitionMaterialId + '/change', params)
	},
	// 2021-03-01
	findBySerialNo(params) {
		return axios.get('/mms/requisitions/find-by-serial-no', params);
	},
	// 2021-03-01
	customInsert(params) {
		return axios.post('/mms/requisitions/custom-insert', params)
	},
	// countByState(params) {
	// 	return axios.get('/mms/requisitions/count-by-state', params)
	// },
	// 2021-12-25
	directFeedOrderMatierials(params) {
		return axios.post('/mms/requisitions/direct-feed-order-matierials', params)
	},
	// 2021-12-25
	directFeedPurchaseMatierials(params) {
		return axios.post('/mms/requisitions/direct-feed-purchase-matierials', params)
	},
}

